import { createSelector } from 'reselect';

const getFiltersStoresAccesor = state => state.store.filters;

export const filtersStoresSelector = createSelector(getFiltersStoresAccesor, filters => filters);

export const filtersStoresToUseInQuerySelector = createSelector(getFiltersStoresAccesor, filters => {
    const _filters = {};

    if (filters.search.toString().length) {
        _filters.search = filters.search;
    }

    if (filters.enabled !== null && typeof filters.enabled !== 'undefined') {
        _filters.enabled = filters.enabled;
    }

    if (filters.type !== null && typeof filters.type !== 'undefined') {
        _filters.type = filters.type;
    }

    if (filters.from_created !== null && typeof filters.from_created !== 'undefined') {
        _filters.from_created = filters.from_created;
    }

    if (filters.to_created !== null && typeof filters.to_created !== 'undefined') {
        _filters.to_created = filters.to_created;
    }

    return _filters;
});
